import React, { useState } from 'react';
import { Typography, Select, Paper } from '@material-ui/core';

const Widget1 = props => {
	const [currentRange, setCurrentRange] = useState(props.currentRange);

	const handleChangeRange = ev => {
		setCurrentRange(ev.target.value);
	};

	return (
		<Paper className="w-full rounded-8 border-1 pt-4">
			<div className="flex items-center justify-center px-2">
				<Typography id={`widget-label-${props.id}`} className="text-16 font-bold" color="primary">
					{props.label}
				</Typography>
			</div>
			<div className="text-center pt-2 pb-2">
				<Typography
					id={`widget-data-display-${props.id}`}
					className={`text-48 font-bold leading-none text-${props.color}`}
				>
					{props.data[currentRange]}
				</Typography>
				<Select
					id={`widget-select-${props.id}`}
					label={props.label}
					native
					value={currentRange}
					onChange={handleChangeRange}
					disableUnderline={true}
				>
					{Object.entries(props.ranges).map(([key, n]) => (
						<option key={key} value={key} className="font-bold">
							{n}
							{/* <Typography ></Typography> */}
						</option>
					))}
				</Select>
			</div>
			<div className="flex items-center px-10 pb-2 h-35 border-t-1">
				<Typography className="text-14 flex w-full" color="textSecondary">
					<span id={`widget-extra-label-${props.id}`} className="truncate font-bold">
						{props.extraLabel}
					</span>
					:
					<b id={`widget-extra-data-${props.id}`} className="pl-4 font-bold">
						{props.extraData}
					</b>
				</Typography>
			</div>
		</Paper>
	);
};

export default React.memo(Widget1);
